import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row} from 'reactstrap';
import SearchCreditNotes from './components/SearchCreditNotes';

const CreditNotes = ({ history, location }) => {

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Listado de Notas Credito</h3>
                </Col>
            </Row>
            <SearchCreditNotes />
        </Container>
    );
}
export default CreditNotes;